import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { UXPContext } from "@core/context/Context";
import { hasValue } from "@utils";
import Icon from "@icon/Icon";
import classNames from 'classnames';
import ButtonComponent from "@widget/buttons/ButtonComponent";
import IconButton from "@widget/buttons/IconButton";
const Alert = (props) => {
    const context = React.useContext(UXPContext);
    const { id, title, content, autoClose, closeAfter, onClose, closeButtonTitle, showCloseBtn, createdAt, remove, icon, variant = 'default' } = props;
    const defaultIconMap = {
        default: ['fas', 'bell'],
        error: ['fas', 'times-circle'],
        info: ['fas', 'info-circle'],
        warning: ['fas', 'exclamation-triangle'],
        success: ['fas', 'check-circle'],
    };
    const alertRef = React.useRef(null);
    // Handle auto-close functionality
    React.useEffect(() => {
        if (autoClose) {
            const now = new Date().getTime();
            const elapsed = now - (createdAt || now);
            const remaining = closeAfter - elapsed;
            if (remaining > 0) {
                const timeout = setTimeout(() => {
                    handleRemove();
                }, remaining);
                return () => clearTimeout(timeout);
            }
            else {
                handleRemove();
            }
        }
    }, [id, remove, autoClose, closeAfter, createdAt]);
    // Handle alert removal with animation
    const handleRemove = () => {
        if (alertRef.current) {
            alertRef.current.classList.remove('uxpcore_alert--show');
            alertRef.current.classList.add('uxpcore_alert--hide');
            setTimeout(() => {
                remove(id);
                if (onClose)
                    onClose();
            }, 300);
        }
    };
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                handleRemove();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [handleRemove]);
    const defaultIcon = defaultIconMap[variant];
    return (_jsxs("div", { className: classNames('uxpcore_alert', `uxpcore_alert--show`, `uxpcore_alert--${variant}`, { 'uxpcore_alert--has-footer': showCloseBtn }), ref: alertRef, children: [_jsxs("div", { className: "uxpcore_alert__header", children: [_jsx("div", { className: "uxpcore_alert__title", children: typeof title === 'string' ? (_jsxs("div", { className: "uxpcore_alert__title-content", children: [_jsx("div", { className: "uxpcore_alert__icon", children: _jsx(Icon, { icon: hasValue(icon) ? icon : defaultIcon }) }), _jsx("div", { className: "uxpcore_alert__title-text", children: title })] })) : (title()) }), showCloseBtn && (_jsx(IconButton, { type: "close", onClick: handleRemove, variant: "secondary", size: "small", className: "uxpcore_alert__close-btn" }))] }), _jsx("div", { className: "uxpcore_alert__body", children: typeof content === 'string' ? content : content() }), showCloseBtn && (_jsx("div", { className: "uxpcore_alert__footer", children: _jsx(ButtonComponent, { title: closeButtonTitle, onClick: handleRemove, variant: variant === 'success' ? 'success' :
                        variant === 'error' ? 'danger' :
                            variant === 'warning' ? 'warning' :
                                variant === 'info' ? 'info' :
                                    'primary', size: "small", className: "uxpcore_alert__action-btn" }) }))] }, id));
};
export default Alert;
